// tanstack
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/$accountId/_user/alarms/alarm-groups')({
  component: () => <Outlet />,
  staticData: { crumb: 'alarms:alarmGroups.title' },
});
